import axiosInstance from './axios-instance';

export const getMasterAvailability = (masterIds: string[], locationId: string, date: string, time: number) =>
  axiosInstance.get<string[]>('master/availability', { params: { masterIds, locationId, date, time }});
